import type { MuiPage } from '@mui/internal-core-docs/MuiPage';

const chartsApiPages: MuiPage[] = [
  {
    pathname: '/x/api/charts/animated-area',
    title: 'AnimatedArea',
  },
  {
    pathname: '/x/api/charts/animated-line',
    title: 'AnimatedLine',
  },
  {
    pathname: '/x/api/charts/area-element',
    title: 'AreaElement',
  },
  {
    pathname: '/x/api/charts/area-plot',
    title: 'AreaPlot',
  },
  {
    pathname: '/x/api/charts/bar-chart',
    title: 'BarChart',
  },
  {
    pathname: '/x/api/charts/bar-chart-premium',
    title: 'BarChartPremium',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/bar-chart-pro',
    title: 'BarChartPro',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/bar-element',
    title: 'BarElement',
  },
  {
    pathname: '/x/api/charts/bar-label',
    title: 'BarLabel',
  },
  {
    pathname: '/x/api/charts/bar-plot',
    title: 'BarPlot',
  },
  {
    pathname: '/x/api/charts/bar-plot-premium',
    title: 'BarPlotPremium',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/candlestick-chart',
    title: 'CandlestickChart',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/candlestick-plot',
    title: 'CandlestickPlot',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/charts-axis',
    title: 'ChartsAxis',
  },
  {
    pathname: '/x/api/charts/charts-axis-highlight',
    title: 'ChartsAxisHighlight',
  },
  {
    pathname: '/x/api/charts/charts-axis-highlight-value',
    title: 'ChartsAxisHighlightValue',
  },
  {
    pathname: '/x/api/charts/charts-axis-tooltip-content',
    title: 'ChartsAxisTooltipContent',
  },
  {
    pathname: '/x/api/charts/charts-brush-overlay',
    title: 'ChartsBrushOverlay',
  },
  {
    pathname: '/x/api/charts/charts-clip-path',
    title: 'ChartsClipPath',
  },
  {
    pathname: '/x/api/charts/charts-container',
    title: 'ChartsContainer',
  },
  {
    pathname: '/x/api/charts/charts-container-premium',
    title: 'ChartsContainerPremium',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/charts-container-pro',
    title: 'ChartsContainerPro',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/charts-data-provider',
    title: 'ChartsDataProvider',
  },
  {
    pathname: '/x/api/charts/charts-data-provider-premium',
    title: 'ChartsDataProviderPremium',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/charts-data-provider-pro',
    title: 'ChartsDataProviderPro',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/charts-geo-data-provider-premium',
    title: 'ChartsGeoDataProviderPremium',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/charts-grid',
    title: 'ChartsGrid',
  },
  {
    pathname: '/x/api/charts/charts-item-tooltip-content',
    title: 'ChartsItemTooltipContent',
  },
  {
    pathname: '/x/api/charts/charts-legend',
    title: 'ChartsLegend',
  },
  {
    pathname: '/x/api/charts/charts-localization-provider',
    title: 'ChartsLocalizationProvider',
  },
  {
    pathname: '/x/api/charts/charts-radial-axis-highlight',
    title: 'ChartsRadialAxisHighlight',
  },
  {
    pathname: '/x/api/charts/charts-radial-data-provider',
    title: 'ChartsRadialDataProvider',
  },
  {
    pathname: '/x/api/charts/charts-radial-data-provider-premium',
    title: 'ChartsRadialDataProviderPremium',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/charts-radial-grid',
    title: 'ChartsRadialGrid',
  },
  {
    pathname: '/x/api/charts/charts-radius-axis',
    title: 'ChartsRadiusAxis',
  },
  {
    pathname: '/x/api/charts/charts-reference-line',
    title: 'ChartsReferenceLine',
  },
  {
    pathname: '/x/api/charts/charts-rotation-axis',
    title: 'ChartsRotationAxis',
  },
  {
    pathname: '/x/api/charts/charts-surface',
    title: 'ChartsSurface',
  },
  {
    pathname: '/x/api/charts/charts-text',
    title: 'ChartsText',
  },
  {
    pathname: '/x/api/charts/charts-toolbar-image-export-trigger',
    title: 'ChartsToolbarImageExportTrigger',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/charts-toolbar-print-export-trigger',
    title: 'ChartsToolbarPrintExportTrigger',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/charts-toolbar-pro',
    title: 'ChartsToolbarPro',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/charts-toolbar-range-button-trigger',
    title: 'ChartsToolbarRangeButtonTrigger',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/charts-toolbar-zoom-in-trigger',
    title: 'ChartsToolbarZoomInTrigger',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/charts-toolbar-zoom-out-trigger',
    title: 'ChartsToolbarZoomOutTrigger',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/charts-tooltip',
    title: 'ChartsTooltip',
  },
  {
    pathname: '/x/api/charts/charts-tooltip-container',
    title: 'ChartsTooltipContainer',
  },
  {
    pathname: '/x/api/charts/charts-wrapper',
    title: 'ChartsWrapper',
  },
  {
    pathname: '/x/api/charts/charts-x-axis',
    title: 'ChartsXAxis',
  },
  {
    pathname: '/x/api/charts/charts-y-axis',
    title: 'ChartsYAxis',
  },
  {
    pathname: '/x/api/charts/charts-zoom-slider',
    title: 'ChartsZoomSlider',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/continuous-color-legend',
    title: 'ContinuousColorLegend',
  },
  {
    pathname: '/x/api/charts/focused-funnel-section',
    title: 'FocusedFunnelSection',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/focused-heatmap-cell',
    title: 'FocusedHeatmapCell',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/focused-radar-mark',
    title: 'FocusedRadarMark',
  },
  {
    pathname: '/x/api/charts/focused-range-bar',
    title: 'FocusedRangeBar',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/focused-sankey-link',
    title: 'FocusedSankeyLink',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/focused-sankey-node',
    title: 'FocusedSankeyNode',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/funnel-chart',
    title: 'FunnelChart',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/funnel-plot',
    title: 'FunnelPlot',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/gauge',
    title: 'Gauge',
  },
  {
    pathname: '/x/api/charts/gauge-container',
    title: 'GaugeContainer',
  },
  {
    pathname: '/x/api/charts/geo-data-plot',
    title: 'GeoDataPlot',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/graticule',
    title: 'Graticule',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/heatmap',
    title: 'Heatmap',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/heatmap-cell',
    title: 'HeatmapCell',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/heatmap-plot',
    title: 'HeatmapPlot',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/heatmap-premium',
    title: 'HeatmapPremium',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/heatmap-tooltip',
    title: 'HeatmapTooltip',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/heatmap-tooltip-content',
    title: 'HeatmapTooltipContent',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/highlighted-scatter-mark',
    title: 'HighlightedScatterMark',
  },
  {
    pathname: '/x/api/charts/line-chart',
    title: 'LineChart',
  },
  {
    pathname: '/x/api/charts/line-chart-pro',
    title: 'LineChartPro',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/line-element',
    title: 'LineElement',
  },
  {
    pathname: '/x/api/charts/line-highlight-element',
    title: 'LineHighlightElement',
  },
  {
    pathname: '/x/api/charts/line-highlight-plot',
    title: 'LineHighlightPlot',
  },
  {
    pathname: '/x/api/charts/line-plot',
    title: 'LinePlot',
  },
  {
    pathname: '/x/api/charts/map-shape',
    title: 'MapShape',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/map-shape-plot',
    title: 'MapShapePlot',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/mark-element',
    title: 'MarkElement',
  },
  {
    pathname: '/x/api/charts/mark-plot',
    title: 'MarkPlot',
  },
  {
    pathname: '/x/api/charts/pie-arc',
    title: 'PieArc',
  },
  {
    pathname: '/x/api/charts/pie-arc-label',
    title: 'PieArcLabel',
  },
  {
    pathname: '/x/api/charts/pie-arc-label-plot',
    title: 'PieArcLabelPlot',
  },
  {
    pathname: '/x/api/charts/pie-arc-plot',
    title: 'PieArcPlot',
  },
  {
    pathname: '/x/api/charts/piecewise-color-legend',
    title: 'PiecewiseColorLegend',
  },
  {
    pathname: '/x/api/charts/pie-chart',
    title: 'PieChart',
  },
  {
    pathname: '/x/api/charts/pie-chart-pro',
    title: 'PieChartPro',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/pie-plot',
    title: 'PiePlot',
  },
  {
    pathname: '/x/api/charts/radar-axis',
    title: 'RadarAxis',
  },
  {
    pathname: '/x/api/charts/radar-axis-highlight',
    title: 'RadarAxisHighlight',
  },
  {
    pathname: '/x/api/charts/radar-chart',
    title: 'RadarChart',
  },
  {
    pathname: '/x/api/charts/radar-chart-pro',
    title: 'RadarChartPro',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/radar-grid',
    title: 'RadarGrid',
  },
  {
    pathname: '/x/api/charts/radar-metric-labels',
    title: 'RadarMetricLabels',
  },
  {
    pathname: '/x/api/charts/radar-series-area',
    title: 'RadarSeriesArea',
  },
  {
    pathname: '/x/api/charts/radar-series-marks',
    title: 'RadarSeriesMarks',
  },
  {
    pathname: '/x/api/charts/radar-series-plot',
    title: 'RadarSeriesPlot',
  },
  {
    pathname: '/x/api/charts/radial-area-plot',
    title: 'RadialAreaPlot',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/radial-bar-chart',
    title: 'RadialBarChart',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/radial-bar-plot',
    title: 'RadialBarPlot',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/radial-line-chart',
    title: 'RadialLineChart',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/radial-line-highlight-plot',
    title: 'RadialLineHighlightPlot',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/radial-line-plot',
    title: 'RadialLinePlot',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/radial-mark-plot',
    title: 'RadialMarkPlot',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/range-bar-plot',
    title: 'RangeBarPlot',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/sankey-chart',
    title: 'SankeyChart',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/sankey-data-provider',
    title: 'SankeyDataProvider',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/sankey-plot',
    title: 'SankeyPlot',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/sankey-tooltip',
    title: 'SankeyTooltip',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/sankey-tooltip-content',
    title: 'SankeyTooltipContent',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/scatter',
    title: 'Scatter',
  },
  {
    pathname: '/x/api/charts/scatter-chart',
    title: 'ScatterChart',
  },
  {
    pathname: '/x/api/charts/scatter-chart-premium',
    title: 'ScatterChartPremium',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/scatter-chart-pro',
    title: 'ScatterChartPro',
    plan: 'pro',
  },
  {
    pathname: '/x/api/charts/scatter-plot',
    title: 'ScatterPlot',
  },
  {
    pathname: '/x/api/charts/scatter-plot-premium',
    title: 'ScatterPlotPremium',
    plan: 'premium',
  },
  {
    pathname: '/x/api/charts/spark-line-chart',
    title: 'SparkLineChart',
  },
  {
    pathname: '/x/api/charts/toolbar',
    title: 'Toolbar',
  },
  {
    pathname: '/x/api/charts/toolbar-button',
    title: 'ToolbarButton',
  },
];
export default chartsApiPages;
